import React from 'react';
import { Link } from 'react-router-dom';
import { useTheme } from '../../contexts/ThemeContext';
import { useAuth } from '../../contexts/AuthContext';
import './Footer.css';

const Footer: React.FC = () => {
  const { currentSport, theme } = useTheme();
  const { user } = useAuth();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer" style={{ backgroundColor: theme.colors.surface }}>
      <div className="container">
        <div className="footer-content">
          <div className="footer-brand">
            <span className="footer-sport-icon">
              {currentSport.id === 'pickleball' ? (
                <img 
                  src="/pickleball-icon.svg" 
                  alt="Pickleball Logo" 
                  className="footer-logo-small"
                />
              ) : currentSport.id === 'golf' ? (
                <span className="sport-emoji">⛳</span>
              ) : currentSport.id === 'tennis' ? (
                <img 
                  src="/tennis-icon.svg" 
                  alt="Tennis Logo" 
                  className="footer-logo-small"
                />
              ) : currentSport.id === 'hiking' ? (
                <span className="sport-emoji">🥾</span>
              ) : (
                <span className="sport-emoji">🎾</span>
              )}
            </span>
            <span className="footer-app-name">{currentSport.displayName}</span>
          </div>
          
          <div className="footer-links">
            <Link to="/blog" className="footer-link">Blog</Link>
            <a href="/privacy" className="footer-link">Privacy Policy</a>
            <a href="/terms" className="footer-link">Terms of Service</a>
            <a href="/contact" className="footer-link">Contact</a>
            {!user && (
              <>
                <Link to="/signin" className="footer-link">Sign In</Link>
                <Link to="/signup" className="footer-link footer-signup">Sign Up</Link>
              </>
            )}
          </div>
          
          <div className="footer-copyright">
            © {currentYear} {currentSport.displayName}. All rights reserved.
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
